//TODO implement typography definitions
export default {};
